export default "__VITE_ASSET__l3M0MwdM__"